// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23e5e7eb%27 fill-opacity=%270.4%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
   DESIGN SYSTEM - Chat Platform
   ============================================= */

:root {
  /* Primary Colors - Refined Forest Green */
  --color-primary: #075E54;
  --color-primary-dark: #054c44;
  --color-primary-light: #128C7E;

  /* Secondary Colors */
  --color-secondary: #34B7F1;
  --color-accent: #00A884;

  /* Neutral Colors */
  --color-white: #FFFFFF;
  --color-gray-50: #F8FAFC;
  --color-gray-100: #F1F5F9;
  --color-gray-200: #E2E8F0;
  --color-gray-300: #CBD5E1;
  --color-gray-400: #94A3B8;
  --color-gray-500: #64748B;
  --color-gray-600: #475569;
  --color-gray-700: #334155;
  --color-gray-800: #1E293B;
  --color-gray-900: #0F172A;

  /* Message Bubble Colors */
  --color-bubble-outgoing: #E0F2FE;
  --color-bubble-outgoing-text: #0F172A;
  --color-bubble-incoming: #FFFFFF;
  --color-bubble-incoming-text: #0F172A;
  --color-bubble-agent: #E0F2FE;
  --color-bubble-agent-text: #0F172A;
  --color-bubble-bot: #F3E8FF;
  --color-bubble-bot-text: #4C1D95;

  /* Status Colors */
  --color-success: #10B981;
  --color-warning: #F59E0B;
  --color-error: #EF4444;
  --color-info: #3B82F6;

  /* Tag Colors */
  --tag-red: #EF4444;
  --tag-orange: #F97316;
  --tag-yellow: #EAB308;
  --tag-green: #22C55E;
  --tag-blue: #3B82F6;
  --tag-purple: #8B5CF6;
  --tag-pink: #EC4899;
  --tag-gray: #6B7280;

  /* Spacing */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.25rem;
  --space-6: 1.5rem;
  --space-8: 2rem;
  --space-10: 2.5rem;
  --space-12: 3rem;

  /* Typography */
  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-size-xs: 0.75rem;
  --font-size-sm: 0.875rem;
  --font-size-base: 1rem;
  --font-size-lg: 1.125rem;
  --font-size-xl: 1.25rem;
  --font-size-2xl: 1.5rem;

  /* Border Radius */
  --radius-sm: 0.25rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-full: 9999px;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);

  /* Transitions */
  --transition-fast: 150ms ease;
  --transition-normal: 250ms ease;
  --transition-slow: 350ms ease;

  /* Z-Index */
  --z-dropdown: 100;
  --z-modal: 2000;
  --z-tooltip: 3000;

  /* Premium Utilities */
  --glass-bg: rgba(255, 255, 255, 0.7);
  --glass-border: rgba(255, 255, 255, 0.3);
  --glass-blur: blur(12px);
  --gradient-premium: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  --gradient-subtle: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* Cali Marketing Theme */
body.theme-marketing {
  --color-primary: #d946ef; /* Fuchsia */
  --color-primary-dark: #a21caf;
  --color-primary-light: #e879f9;
  --color-secondary: #f472b6; /* Pink */
  --color-accent: #c026d3;
  --gradient-premium: linear-gradient(135deg, #e879f9 0%, #a21caf 100%);
}

.glass-morphism {
  background: var(--glass-bg);
  backdrop-filter: var(--glass-blur);
  -webkit-backdrop-filter: var(--glass-blur);
  border: 1px solid var(--glass-border);
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(15, 23, 42, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.premium-gradient {
  background: var(--gradient-premium);
}

/* =============================================
   BASE STYLES
   ============================================= */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
}

body {
  font-family: var(--font-family);
  font-size: var(--font-size-base);
  color: var(--color-gray-900);
  background-color: var(--color-gray-100);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overscroll-behavior-x: none;
}

/* =============================================
   LAYOUT
   ============================================= */

.app-container {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

/* Sidebar */
.sidebar {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 360px;
  min-width: 300px;
  max-width: 1000px;
  background-color: var(--color-white);
  border-right: 1px solid var(--color-gray-200);
}

/* Utility to disable transitions and text selection during resize */
.is-resizing,
.is-resizing * {
  cursor: ew-resize !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  transition: none !important;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4);
  background-color: var(--color-gray-50);
  border-bottom: 1px solid var(--color-gray-200);
}

.sidebar-search {
  padding: var(--space-3) var(--space-4);
  background-color: var(--color-gray-50);
}

.conversation-list {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--color-gray-300) transparent;
  /* GPU acceleration for smooth scroll on mobile */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  will-change: scroll-position;
}

.conversation-list::-webkit-scrollbar {
  width: 6px;
}

.conversation-list::-webkit-scrollbar-track {
  background: transparent;
}

.conversation-list::-webkit-scrollbar-thumb {
  background-color: var(--color-gray-300);
  border-radius: var(--radius-full);
}

/* Chat Area */
.chat-container {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  background-color: var(--color-gray-50);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3) var(--space-4);
  background-color: var(--color-gray-50);
  border-bottom: 1px solid var(--color-gray-200);
}

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden !important;
  padding: var(--space-4);
  scrollbar-width: thin;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  /* Smooth momentum scrolling on iOS */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.chat-input-container {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-4);
  background-color: var(--color-gray-50);
  border-top: 1px solid var(--color-gray-200);
}

/* =============================================
   CONVERSATION ITEM
   ============================================= */

.conversation-item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  cursor: pointer;
  background-color: var(--color-white);
  border-bottom: 1px solid var(--color-gray-100);
  transition: background-color var(--transition-fast);
  border-left: 3px solid transparent;
  /* Isolate reflows to each item */
  contain: layout style;
}

.conversation-item.unread {
  background-color: rgba(18, 140, 126, 0.05);
}

.conversation-item:hover {
  background-color: var(--color-gray-50);
}

.conversation-item.active {
  background-color: var(--color-gray-100);
  border-left: 3px solid var(--color-primary);
}

.conversation-avatar {
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-white);
  font-weight: 600;
  flex-shrink: 0;
}

.conversation-content {
  flex: 1 1;
  min-width: 0;
}

.conversation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-1);
}

.conversation-name {
  font-weight: 600;
  font-size: var(--font-size-sm);
  color: var(--color-gray-900);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-time {
  font-size: var(--font-size-xs);
  color: var(--color-gray-500);
  flex-shrink: 0;
}

.conversation-preview {
  font-size: var(--font-size-sm);
  color: var(--color-gray-600);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.conversation-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: var(--space-1);
}

.unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 var(--space-1);
  background-color: var(--color-primary-light);
  color: var(--color-white);
  font-size: var(--font-size-xs);
  font-weight: 600;
  border-radius: var(--radius-full);
}

/* =============================================
   MESSAGE BUBBLES
   ============================================= */

.message-group {
  margin-bottom: var(--space-4);
}

.date-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: var(--space-6) 0;
}

.date-separator-text {
  padding: var(--space-1) var(--space-3);
  background-color: var(--color-white);
  border-radius: var(--radius-lg);
  font-size: var(--font-size-xs);
  color: var(--color-gray-600);
  box-shadow: var(--shadow-sm);
}

.message {
  display: flex;
  margin-bottom: var(--space-2);
  width: 100%;
  max-width: 100%;
  /* overflow: hidden; Removed to allow absolute positioned elements (forward btn) to be visible outside */
}

.message.outgoing {
  justify-content: flex-end !important;
}

.message.incoming {
  justify-content: flex-start !important;
}

.message-container {
  max-width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* overflow: hidden; Removed to allow absolute elements (forward btn) */
  min-width: 0;
  width: auto;
}

.message.outgoing .message-container {
  align-items: flex-end;
  /* Align bubble and meta to the right */
}

.message-bubble {
  width: fit-content;
  max-width: 100% !important;
  min-width: 60px;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-lg);
  position: relative;
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
  word-break: break-all !important;
  display: flex;
  flex-direction: column;
  /* overflow: hidden !important; Removed to allow reactions outside */
  box-sizing: border-box;
}

.message.outgoing .message-bubble {
  background-color: var(--color-bubble-outgoing);
  color: var(--color-bubble-outgoing-text);
  border-bottom-right-radius: var(--radius-sm);
}

.message.incoming .message-bubble {
  background-color: var(--color-bubble-incoming);
  color: var(--color-bubble-incoming-text);
  border-bottom-left-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
}

.message.agent .message-bubble {
  background-color: var(--color-bubble-agent);
  color: var(--color-bubble-agent-text);
}

.message.bot .message-bubble {
  background-color: var(--color-bubble-bot);
  color: var(--color-bubble-bot-text);
}

.message-text {
  font-size: var(--font-size-sm);
  line-height: 1.5;
  white-space: pre-wrap !important;
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
  max-width: 100% !important;
  margin: 0;
  overflow: hidden !important;
}

.message-text a,
.message-text strong,
.message-text span,
.message-text * {
  word-wrap: break-word !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
  max-width: 100% !important;
  display: inline !important;
}

.message-text a {
  color: inherit;
  text-decoration: underline;
}

.message-meta {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-1);
  margin-top: var(--space-1);
}

.message-time {
  font-size: var(--font-size-xs);
  opacity: 0.7;
}

.message-status {
  display: flex;
  align-items: center;
}

/* =============================================
   TAGS
   ============================================= */

.tag {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: 500;
  white-space: nowrap;
}

.tag-small {
  padding: 2px var(--space-2);
  font-size: 10px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

/* =============================================
   AI TOGGLE
   ============================================= */

.ai-toggle {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.ai-toggle-label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--color-gray-600);
  transition: color var(--transition-fast);
}

.ai-toggle-label.active {
  color: var(--color-primary);
}

.toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: var(--color-gray-300);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.toggle-switch.active {
  background-color: var(--color-primary-light);
}

.toggle-switch-handle {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: var(--color-white);
  border-radius: var(--radius-full);
  box-shadow: var(--shadow-sm);
  transition: transform var(--transition-fast);
}

.toggle-switch.active .toggle-switch-handle {
  transform: translateX(20px);
}

/* =============================================
   INPUTS
   ============================================= */

.search-input {
  width: 100%;
  padding: var(--space-2) var(--space-4);
  padding-left: var(--space-10);
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-300);
  border-radius: var(--radius-lg);
  font-size: var(--font-size-sm);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.search-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(18, 140, 126, 0.1);
}

.message-input {
  flex: 1 1;
  padding: var(--space-3) var(--space-4);
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-300);
  border-radius: var(--radius-xl);
  font-size: var(--font-size-sm);
  resize: none;
  transition: border-color var(--transition-fast);
}

.message-input:focus {
  outline: none;
  border-color: var(--color-primary);
}

/* =============================================
   BUTTONS
   ============================================= */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  border: none;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn-primary {
  background-color: var(--color-primary);
  color: var(--color-white);
}

.btn-primary:hover {
  background-color: var(--color-primary-dark);
}

.btn-primary:disabled {
  background-color: var(--color-gray-300);
  cursor: not-allowed;
}

.btn-icon {
  padding: var(--space-2);
  background-color: transparent;
  color: var(--color-gray-600);
  border-radius: var(--radius-full);
}

.btn-icon:hover {
  background-color: var(--color-gray-100);
}

.btn-send {
  width: 44px;
  height: 44px;
  padding: 0;
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: var(--radius-full);
}

.btn-send:hover {
  background-color: var(--color-primary-dark);
}

.btn-send:disabled {
  background-color: var(--color-gray-300);
}

/* =============================================
   MODALS
   ============================================= */

.modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
  animation: fadeIn var(--transition-fast);
}

.modal {
  background-color: var(--color-white);
  border-radius: var(--radius-xl);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  max-width: 500px;
  width: 90%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp var(--transition-normal);
  position: relative;
  z-index: 201;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4);
  border-bottom: 1px solid var(--color-gray-200);
}

.modal-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
}

.modal-body {
  flex: 1 1;
  padding: var(--space-4);
  overflow-y: auto;
  min-height: 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: var(--space-4);
  border-top: 1px solid var(--color-gray-200);
}

/* =============================================
   STATUS INDICATORS
   ============================================= */

.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: 500;
}

.status-ai {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--color-success);
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.status-manual {
  background-color: rgba(59, 130, 246, 0.1);
  color: var(--color-info);
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.connection-dot {
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
}

.connection-dot.connected {
  background-color: var(--color-success);
}

.connection-dot.disconnected {
  background-color: var(--color-error);
}

/* =============================================
   ANIMATIONS
   ============================================= */

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {

  50% {
    opacity: 0.5;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* =============================================
   MULTI-SELECTION STYLES
   ============================================= */

.conversation-item.multi-selected {
  background-color: rgba(18, 140, 126, 0.08) !important;
}

.selection-checkbox-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: var(--space-2);
  margin-left: -4px;
  align-self: center;
  animation: slideInLeft var(--transition-fast);
}

.selection-checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid var(--color-gray-300);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  background-color: var(--color-white);
  flex-shrink: 0;
}

.selection-checkbox.checked {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.inner-check {
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 2px;
  animation: popIn var(--transition-fast);
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes popIn {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

.loading {
  animation: pulse 1.5s infinite;
}

/* =============================================
   RESPONSIVE - MOBILE
   ============================================= */

@media (max-width: 1024px) {

  *,
  *::before,
  *::after {
    transition: none !important;
    animation-duration: 0s !important;
  }

  .app-container {
    flex-direction: column;
    overflow-x: hidden !important;
    position: relative;
    width: 100vw;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw !important;
    max-width: 100vw !important;
    min-width: 100vw !important;
    z-index: var(--z-modal);
    background-color: var(--color-white);
    display: none;
    overflow-x: hidden !important;
    transition: none !important;
    transform: none !important;
  }

  .sidebar.open {
    display: flex;
  }

  .chat-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw !important;
    height: 100% !important;
    overflow-x: hidden !important;
    transition: none !important;
    transform: none !important;
  }

  .message {
    width: 100% !important;
    display: flex !important;
  }

  .message.outgoing {
    justify-content: flex-end !important;
  }

  .message.incoming {
    justify-content: flex-start !important;
  }

  .message-container {
    max-width: 85% !important;
  }

  .message-bubble {
    width: fit-content !important;
    max-width: 100% !important;
  }

  .chat-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: var(--color-white);
    padding: var(--space-2) var(--space-3);
  }

  /* Compacting header for mobile */
  .chat-header-actions {
    gap: var(--space-1) !important;
  }

  .chat-header-info {
    gap: var(--space-2) !important;
  }

  /* Optimize AI Toggle on mobile */
  .ai-toggle {
    gap: 4px;
    margin-right: 4px;
  }

  .ai-toggle-label {
    font-size: 11px;
    padding: 2px 4px;
    background-color: var(--color-gray-100);
    border-radius: 4px;
  }

  .ai-toggle-label svg {
    width: 12px;
    height: 12px;
    margin-right: 2px !important;
  }

  /* Smaller toggle switch on mobile */
  .toggle-switch {
    width: 38px;
    height: 22px;
  }

  .toggle-switch-handle {
    width: 18px;
    height: 18px;
  }

  .toggle-switch.active .toggle-switch-handle {
    transform: translateX(16px);
  }

  /* Smaller header buttons on mobile */
  .chat-header-actions .btn-icon {
    padding: 6px;
    width: 32px;
    height: 32px;
  }

  .chat-input-container {
    position: sticky;
    bottom: 0;
    z-index: 10;
    background-color: var(--color-white);
    padding: var(--space-2) var(--space-3);
  }

  .sidebar-header {
    padding: var(--space-3);
  }

  .conversation-avatar {
    width: 44px;
    height: 44px;
  }

  /* Hide tag filter on very small screens */
  @media (max-height: 600px) {
    .sidebar-search+div {
      max-height: 60px;
      overflow: hidden;
    }
  }

  /* Modal adjustments for mobile */
  .modal {
    width: 95%;
    max-height: 90vh;
    margin: var(--space-2);
  }

  /* Chat input mobile optimization */
  .chat-input-container {
    padding: var(--space-2) var(--space-3) !important;
    padding-bottom: calc(var(--space-3) + env(safe-area-inset-bottom, 12px)) !important;
    gap: var(--space-1) !important;
  }

  .chat-input-container .btn-icon {
    padding: var(--space-1) !important;
    width: 36px;
    height: 36px;
  }

  .chat-input-container .btn-send {
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }

  .chat-input-container .message-input {
    padding: var(--space-2) var(--space-3) !important;
    min-width: 0;
  }
}

/* Very small screens */
@media (max-width: 375px) {
  .sidebar-header {
    padding: var(--space-2);
  }

  .conversation-item {
    padding: var(--space-2) var(--space-3);
  }

  /* .status-indicator display:none removed */

  /* Hide emoji button to save space on very small screens */
  .chat-input-container>div:has(.btn-icon) {
    display: none;
  }

  .chat-input-container .btn-icon:first-of-type {
    display: flex;
  }

  .chat-input-container {
    gap: 2px !important;
  }

  .chat-input-container .btn-icon {
    width: 32px !important;
    height: 32px !important;
  }

  .chat-input-container .btn-send {
    width: 36px !important;
    height: 36px !important;
  }
}

/* =============================================
   UTILITIES
   ============================================= */

.hidden {
  display: none !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* =============================================
   MOBILE SCROLL FIXES
   ============================================= */

html,
body {
  overflow-x: hidden !important;
  width: 100%;
  max-width: 100vw;
  position: fixed;
  /* Previene rebote en iOS */
  height: 100%;
  overscroll-behavior-y: none;
}

.app-container {
  height: 100%;
  height: 100dvh;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  position: relative;
}

/* Permitir scroll solo donde es necesario */
.sidebar,
.chat-messages,
.conversation-list,
.modal-body {
  overscroll-behavior: contain;
}

/* =============================================
   UTILITIES & COMPONENTS ADDITIONS
   ============================================= */

/* Small icon button */
.btn-icon-small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: var(--radius-md);
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color var(--transition-fast);
  padding: 0;
}

.btn-icon-small:hover {
  background-color: var(--color-gray-200);
}

/* Equivalent to tailwind hover:bg-gray-50 */
.hover\\:bg-gray-50:hover {
  background-color: var(--color-gray-50);
}

/* Highlight effect for quoted messages */
.message-highlight {
    animation: message-flash 2.5s ease-out;
}

@keyframes message-flash {
    0% { background-color: rgba(18, 140, 126, 0.4); transform: scale(1.02); }
    15% { background-color: rgba(18, 140, 126, 0.1); transform: scale(1); }
    100% { background-color: transparent; }
}

/* =============================================
   MESSAGE BUBBLE INTERACTIVE ELEMENTS
   (global rules — avoid per-message style tags)
   ============================================= */

/* Show chevron menu button on bubble hover */
.message-bubble:hover .menu-chevron {
    opacity: 1 !important;
}

/* Always show chevron on touch devices */
@media (hover: none) {
    .menu-chevron {
        opacity: 1 !important;
        background: rgba(255,255,255,0.9) !important;
    }
}

/* Show forward button on message hover */
.message:hover .forward-btn {
    opacity: 1 !important;
    pointer-events: auto !important;
}

/* =============================================
   TENANT SELECTOR RESPONSIVE LAYOUT
   ============================================= */

@media (max-width: 900px) {
    .tenant-selector-page {
        flex-direction: column !important;
        width: 100% !important;
        min-height: 100dvh !important;
        height: auto !important;
        overflow-x: hidden !important;
        overflow-y: auto !important;
    }

    .tenant-selector-sidebar {
        width: 100% !important;
        min-width: 0 !important;
        max-width: none !important;
        flex: 0 0 auto !important;
    }

    .tenant-selector-nav {
        flex: 0 0 auto !important;
        padding: 16px 12px !important;
    }

    .tenant-selector-nav > button {
        width: 100% !important;
    }

    .tenant-selector-main {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        overflow: visible !important;
        flex: 0 0 auto !important;
    }

    .tenant-selector-content {
        max-width: none !important;
        padding: 24px 16px 32px !important;
    }

    .tenant-selector-header {
        align-items: flex-start !important;
        flex-direction: column !important;
        margin-bottom: 28px !important;
    }

    .tenant-selector-header h1 {
        font-size: 22px !important;
        line-height: 1.2 !important;
    }

    .tenant-selector-welcome {
        margin-bottom: 24px !important;
    }

    .tenant-selector-welcome h2 {
        font-size: 24px !important;
        line-height: 1.2 !important;
    }

    .tenant-selector-welcome p {
        font-size: 14px !important;
    }

    .tenant-selector-grid {
        grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr)) !important;
        gap: 16px !important;
    }

    .tenant-selector-card {
        min-width: 0 !important;
        padding: 20px !important;
        border-radius: 18px !important;
    }

    .tenant-selector-new-card {
        min-height: 190px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAElD;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;;EAE9B,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;;EAEvB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;;EAEzB,0BAA0B;EAC1B,gCAAgC;EAChC,qCAAqC;EACrC,gCAAgC;EAChC,qCAAqC;EACrC,6BAA6B;EAC7B,kCAAkC;EAClC,2BAA2B;EAC3B,gCAAgC;;EAEhC,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;;EAErB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;;EAEnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;;EAEhB,eAAe;EACf,yFAAyF;EACzF,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;;EAEvB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;;EAErB,YAAY;EACZ,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;;EAE/E,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;;EAE7B,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;;EAEjB,sBAAsB;EACtB,oCAAoC;EACpC,wCAAwC;EACxC,wBAAwB;EACxB,qEAAqE;EACrE,oEAAoE;AACtE;;AAEA,yBAAyB;AACzB;EACE,wBAAwB,EAAE,YAAY;EACtC,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B,EAAE,SAAS;EACrC,uBAAuB;EACvB,qEAAqE;AACvE;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;kDAEkD;;AAElD;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,uCAAuC;EACvC,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;kDAEkD;;AAElD;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA,oEAAoE;AACpE;;EAEE,4BAA4B;EAC5B,oCAA4B;UAA5B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kDAAkD;EAClD,iDAAiD;EACjD,iCAAiC;EACjC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,sCAAsC;EACtC,yDAAmY;AACrY;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;;kDAEkD;;AAElD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,oCAAoC;EACpC,8CAA8C;EAC9C,mDAAmD;EACnD,kCAAkC;EAClC,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;;kDAEkD;;AAElD;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,wGAAwG;AAC1G;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uEAAuE;EACvE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,oEAAoE;EACpE,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;EAC1B,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;;;EAIE,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;kDAEkD;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;;kDAEkD;;AAElD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,iCAAiC;EACjC,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;kDAEkD;;AAElD;EACE,WAAW;EACX,sCAAsC;EACtC,6BAA6B;EAC7B,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,sCAAsC;EACtC,oCAAoC;EACpC,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;;kDAEkD;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;kDAEkD;;AAElD;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,iDAAiD;EACjD,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;;kDAEkD;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;kDAEkD;;AAElD;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;kDAEkD;;AAElD;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;kDAEkD;;AAElD;;EAEE;;;IAGE,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,oCAAoC;IACpC,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;IAC7B,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,oCAAoC;IACpC,sCAAsC;EACxC;;EAEA,iCAAiC;EACjC;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA,iCAAiC;EACjC;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;;EAEA,oCAAoC;EACpC;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,qCAAqC;EACrC;IACE,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,0CAA0C;EAC1C;IACE;MACE,gBAAgB;MAChB,gBAAgB;IAClB;EACF;;EAEA,iCAAiC;EACjC;IACE,UAAU;IACV,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,mCAAmC;EACnC;IACE,iDAAiD;IACjD,mFAAmF;IACnF,8BAA8B;EAChC;;EAEA;IACE,kCAAkC;IAClC,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,iDAAiD;IACjD,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sCAAsC;EACxC;;EAEA,2CAA2C;;EAE3C,0DAA0D;EAC1D;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;;kDAEkD;;AAElD;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;kDAEkD;;AAElD;;EAEE,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;;;;EAIE,4BAA4B;AAC9B;;AAEA;;kDAEkD;;AAElD,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,uCAAuC;AACzC;;AAEA,4CAA4C;AAC5C;EACE,sCAAsC;AACxC;;AAEA,yCAAyC;AACzC;IACI,sCAAsC;AAC1C;;AAEA;IACI,KAAK,yCAAyC,EAAE,sBAAsB,EAAE;IACxE,MAAM,yCAAyC,EAAE,mBAAmB,EAAE;IACtE,OAAO,6BAA6B,EAAE;AAC1C;;AAEA;;;kDAGkD;;AAElD,6CAA6C;AAC7C;IACI,qBAAqB;AACzB;;AAEA,yCAAyC;AACzC;IACI;QACI,qBAAqB;QACrB,4CAA4C;IAChD;AACJ;;AAEA,yCAAyC;AACzC;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;;kDAEkD;;AAElD;IACI;QACI,iCAAiC;QACjC,sBAAsB;QACtB,6BAA6B;QAC7B,uBAAuB;QACvB,6BAA6B;QAC7B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,4BAA4B;QAC5B,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;QAC1B,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;QAClC,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iFAAiF;QACjF,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* =============================================\n   DESIGN SYSTEM - Chat Platform\n   ============================================= */\n\n:root {\n  /* Primary Colors - Refined Forest Green */\n  --color-primary: #075E54;\n  --color-primary-dark: #054c44;\n  --color-primary-light: #128C7E;\n\n  /* Secondary Colors */\n  --color-secondary: #34B7F1;\n  --color-accent: #00A884;\n\n  /* Neutral Colors */\n  --color-white: #FFFFFF;\n  --color-gray-50: #F8FAFC;\n  --color-gray-100: #F1F5F9;\n  --color-gray-200: #E2E8F0;\n  --color-gray-300: #CBD5E1;\n  --color-gray-400: #94A3B8;\n  --color-gray-500: #64748B;\n  --color-gray-600: #475569;\n  --color-gray-700: #334155;\n  --color-gray-800: #1E293B;\n  --color-gray-900: #0F172A;\n\n  /* Message Bubble Colors */\n  --color-bubble-outgoing: #E0F2FE;\n  --color-bubble-outgoing-text: #0F172A;\n  --color-bubble-incoming: #FFFFFF;\n  --color-bubble-incoming-text: #0F172A;\n  --color-bubble-agent: #E0F2FE;\n  --color-bubble-agent-text: #0F172A;\n  --color-bubble-bot: #F3E8FF;\n  --color-bubble-bot-text: #4C1D95;\n\n  /* Status Colors */\n  --color-success: #10B981;\n  --color-warning: #F59E0B;\n  --color-error: #EF4444;\n  --color-info: #3B82F6;\n\n  /* Tag Colors */\n  --tag-red: #EF4444;\n  --tag-orange: #F97316;\n  --tag-yellow: #EAB308;\n  --tag-green: #22C55E;\n  --tag-blue: #3B82F6;\n  --tag-purple: #8B5CF6;\n  --tag-pink: #EC4899;\n  --tag-gray: #6B7280;\n\n  /* Spacing */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.25rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n  --space-10: 2.5rem;\n  --space-12: 3rem;\n\n  /* Typography */\n  --font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  --font-size-xs: 0.75rem;\n  --font-size-sm: 0.875rem;\n  --font-size-base: 1rem;\n  --font-size-lg: 1.125rem;\n  --font-size-xl: 1.25rem;\n  --font-size-2xl: 1.5rem;\n\n  /* Border Radius */\n  --radius-sm: 0.25rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-full: 9999px;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n\n  /* Transitions */\n  --transition-fast: 150ms ease;\n  --transition-normal: 250ms ease;\n  --transition-slow: 350ms ease;\n\n  /* Z-Index */\n  --z-dropdown: 100;\n  --z-modal: 2000;\n  --z-tooltip: 3000;\n\n  /* Premium Utilities */\n  --glass-bg: rgba(255, 255, 255, 0.7);\n  --glass-border: rgba(255, 255, 255, 0.3);\n  --glass-blur: blur(12px);\n  --gradient-premium: linear-gradient(135deg, #128C7E 0%, #075E54 100%);\n  --gradient-subtle: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n/* Cali Marketing Theme */\nbody.theme-marketing {\n  --color-primary: #d946ef; /* Fuchsia */\n  --color-primary-dark: #a21caf;\n  --color-primary-light: #e879f9;\n  --color-secondary: #f472b6; /* Pink */\n  --color-accent: #c026d3;\n  --gradient-premium: linear-gradient(135deg, #e879f9 0%, #a21caf 100%);\n}\n\n.glass-morphism {\n  background: var(--glass-bg);\n  backdrop-filter: var(--glass-blur);\n  -webkit-backdrop-filter: var(--glass-blur);\n  border: 1px solid var(--glass-border);\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(15, 23, 42, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.premium-gradient {\n  background: var(--gradient-premium);\n}\n\n/* =============================================\n   BASE STYLES\n   ============================================= */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  width: 100%;\n  height: 100%;\n}\n\nbody {\n  font-family: var(--font-family);\n  font-size: var(--font-size-base);\n  color: var(--color-gray-900);\n  background-color: var(--color-gray-100);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overscroll-behavior-x: none;\n}\n\n/* =============================================\n   LAYOUT\n   ============================================= */\n\n.app-container {\n  display: flex;\n  height: 100vh;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* Sidebar */\n.sidebar {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  min-width: 300px;\n  max-width: 1000px;\n  background-color: var(--color-white);\n  border-right: 1px solid var(--color-gray-200);\n}\n\n/* Utility to disable transitions and text selection during resize */\n.is-resizing,\n.is-resizing * {\n  cursor: ew-resize !important;\n  user-select: none !important;\n  transition: none !important;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-4);\n  background-color: var(--color-gray-50);\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.sidebar-search {\n  padding: var(--space-3) var(--space-4);\n  background-color: var(--color-gray-50);\n}\n\n.conversation-list {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: var(--color-gray-300) transparent;\n  /* GPU acceleration for smooth scroll on mobile */\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  will-change: scroll-position;\n}\n\n.conversation-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.conversation-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.conversation-list::-webkit-scrollbar-thumb {\n  background-color: var(--color-gray-300);\n  border-radius: var(--radius-full);\n}\n\n/* Chat Area */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background-color: var(--color-gray-50);\n  background-image: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23e5e7eb' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n}\n\n.chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-3) var(--space-4);\n  background-color: var(--color-gray-50);\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden !important;\n  padding: var(--space-4);\n  scrollbar-width: thin;\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  /* Smooth momentum scrolling on iOS */\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.chat-input-container {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  background-color: var(--color-gray-50);\n  border-top: 1px solid var(--color-gray-200);\n}\n\n/* =============================================\n   CONVERSATION ITEM\n   ============================================= */\n\n.conversation-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: var(--space-3) var(--space-4);\n  cursor: pointer;\n  background-color: var(--color-white);\n  border-bottom: 1px solid var(--color-gray-100);\n  transition: background-color var(--transition-fast);\n  border-left: 3px solid transparent;\n  /* Isolate reflows to each item */\n  contain: layout style;\n}\n\n.conversation-item.unread {\n  background-color: rgba(18, 140, 126, 0.05);\n}\n\n.conversation-item:hover {\n  background-color: var(--color-gray-50);\n}\n\n.conversation-item.active {\n  background-color: var(--color-gray-100);\n  border-left: 3px solid var(--color-primary);\n}\n\n.conversation-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius-full);\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-white);\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.conversation-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.conversation-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-1);\n}\n\n.conversation-name {\n  font-weight: 600;\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-900);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.conversation-time {\n  font-size: var(--font-size-xs);\n  color: var(--color-gray-500);\n  flex-shrink: 0;\n}\n\n.conversation-preview {\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-600);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.conversation-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: var(--space-1);\n}\n\n.unread-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 var(--space-1);\n  background-color: var(--color-primary-light);\n  color: var(--color-white);\n  font-size: var(--font-size-xs);\n  font-weight: 600;\n  border-radius: var(--radius-full);\n}\n\n/* =============================================\n   MESSAGE BUBBLES\n   ============================================= */\n\n.message-group {\n  margin-bottom: var(--space-4);\n}\n\n.date-separator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: var(--space-6) 0;\n}\n\n.date-separator-text {\n  padding: var(--space-1) var(--space-3);\n  background-color: var(--color-white);\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-xs);\n  color: var(--color-gray-600);\n  box-shadow: var(--shadow-sm);\n}\n\n.message {\n  display: flex;\n  margin-bottom: var(--space-2);\n  width: 100%;\n  max-width: 100%;\n  /* overflow: hidden; Removed to allow absolute positioned elements (forward btn) to be visible outside */\n}\n\n.message.outgoing {\n  justify-content: flex-end !important;\n}\n\n.message.incoming {\n  justify-content: flex-start !important;\n}\n\n.message-container {\n  max-width: 80%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  /* overflow: hidden; Removed to allow absolute elements (forward btn) */\n  min-width: 0;\n  width: auto;\n}\n\n.message.outgoing .message-container {\n  align-items: flex-end;\n  /* Align bubble and meta to the right */\n}\n\n.message-bubble {\n  width: fit-content;\n  max-width: 100% !important;\n  min-width: 60px;\n  padding: var(--space-2) var(--space-3);\n  border-radius: var(--radius-lg);\n  position: relative;\n  word-wrap: break-word !important;\n  overflow-wrap: anywhere !important;\n  word-break: break-all !important;\n  display: flex;\n  flex-direction: column;\n  /* overflow: hidden !important; Removed to allow reactions outside */\n  box-sizing: border-box;\n}\n\n.message.outgoing .message-bubble {\n  background-color: var(--color-bubble-outgoing);\n  color: var(--color-bubble-outgoing-text);\n  border-bottom-right-radius: var(--radius-sm);\n}\n\n.message.incoming .message-bubble {\n  background-color: var(--color-bubble-incoming);\n  color: var(--color-bubble-incoming-text);\n  border-bottom-left-radius: var(--radius-sm);\n  box-shadow: var(--shadow-sm);\n}\n\n.message.agent .message-bubble {\n  background-color: var(--color-bubble-agent);\n  color: var(--color-bubble-agent-text);\n}\n\n.message.bot .message-bubble {\n  background-color: var(--color-bubble-bot);\n  color: var(--color-bubble-bot-text);\n}\n\n.message-text {\n  font-size: var(--font-size-sm);\n  line-height: 1.5;\n  white-space: pre-wrap !important;\n  word-wrap: break-word !important;\n  overflow-wrap: anywhere !important;\n  word-break: break-word !important;\n  max-width: 100% !important;\n  margin: 0;\n  overflow: hidden !important;\n}\n\n.message-text a,\n.message-text strong,\n.message-text span,\n.message-text * {\n  word-wrap: break-word !important;\n  overflow-wrap: anywhere !important;\n  word-break: break-word !important;\n  max-width: 100% !important;\n  display: inline !important;\n}\n\n.message-text a {\n  color: inherit;\n  text-decoration: underline;\n}\n\n.message-meta {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: var(--space-1);\n  margin-top: var(--space-1);\n}\n\n.message-time {\n  font-size: var(--font-size-xs);\n  opacity: 0.7;\n}\n\n.message-status {\n  display: flex;\n  align-items: center;\n}\n\n/* =============================================\n   TAGS\n   ============================================= */\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-xs);\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.tag-small {\n  padding: 2px var(--space-2);\n  font-size: 10px;\n}\n\n.tags-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-1);\n}\n\n/* =============================================\n   AI TOGGLE\n   ============================================= */\n\n.ai-toggle {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.ai-toggle-label {\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  color: var(--color-gray-600);\n  transition: color var(--transition-fast);\n}\n\n.ai-toggle-label.active {\n  color: var(--color-primary);\n}\n\n.toggle-switch {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background-color: var(--color-gray-300);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n}\n\n.toggle-switch.active {\n  background-color: var(--color-primary-light);\n}\n\n.toggle-switch-handle {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background-color: var(--color-white);\n  border-radius: var(--radius-full);\n  box-shadow: var(--shadow-sm);\n  transition: transform var(--transition-fast);\n}\n\n.toggle-switch.active .toggle-switch-handle {\n  transform: translateX(20px);\n}\n\n/* =============================================\n   INPUTS\n   ============================================= */\n\n.search-input {\n  width: 100%;\n  padding: var(--space-2) var(--space-4);\n  padding-left: var(--space-10);\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-300);\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-sm);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(18, 140, 126, 0.1);\n}\n\n.message-input {\n  flex: 1;\n  padding: var(--space-3) var(--space-4);\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-300);\n  border-radius: var(--radius-xl);\n  font-size: var(--font-size-sm);\n  resize: none;\n  transition: border-color var(--transition-fast);\n}\n\n.message-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n}\n\n/* =============================================\n   BUTTONS\n   ============================================= */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  border: none;\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.btn-primary {\n  background-color: var(--color-primary);\n  color: var(--color-white);\n}\n\n.btn-primary:hover {\n  background-color: var(--color-primary-dark);\n}\n\n.btn-primary:disabled {\n  background-color: var(--color-gray-300);\n  cursor: not-allowed;\n}\n\n.btn-icon {\n  padding: var(--space-2);\n  background-color: transparent;\n  color: var(--color-gray-600);\n  border-radius: var(--radius-full);\n}\n\n.btn-icon:hover {\n  background-color: var(--color-gray-100);\n}\n\n.btn-send {\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  background-color: var(--color-primary);\n  color: var(--color-white);\n  border-radius: var(--radius-full);\n}\n\n.btn-send:hover {\n  background-color: var(--color-primary-dark);\n}\n\n.btn-send:disabled {\n  background-color: var(--color-gray-300);\n}\n\n/* =============================================\n   MODALS\n   ============================================= */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--z-modal);\n  animation: fadeIn var(--transition-fast);\n}\n\n.modal {\n  background-color: var(--color-white);\n  border-radius: var(--radius-xl);\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  max-width: 500px;\n  width: 90%;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: slideUp var(--transition-normal);\n  position: relative;\n  z-index: 201;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-4);\n  border-bottom: 1px solid var(--color-gray-200);\n}\n\n.modal-title {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n}\n\n.modal-body {\n  flex: 1;\n  padding: var(--space-4);\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  border-top: 1px solid var(--color-gray-200);\n}\n\n/* =============================================\n   STATUS INDICATORS\n   ============================================= */\n\n.status-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  padding: var(--space-1) var(--space-2);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-xs);\n  font-weight: 500;\n}\n\n.status-ai {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: var(--color-success);\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.status-manual {\n  background-color: rgba(59, 130, 246, 0.1);\n  color: var(--color-info);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n}\n\n.connection-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n}\n\n.connection-dot.connected {\n  background-color: var(--color-success);\n}\n\n.connection-dot.disconnected {\n  background-color: var(--color-error);\n}\n\n/* =============================================\n   ANIMATIONS\n   ============================================= */\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes pulse {\n\n  50% {\n    opacity: 0.5;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* =============================================\n   MULTI-SELECTION STYLES\n   ============================================= */\n\n.conversation-item.multi-selected {\n  background-color: rgba(18, 140, 126, 0.08) !important;\n}\n\n.selection-checkbox-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: var(--space-2);\n  margin-left: -4px;\n  align-self: center;\n  animation: slideInLeft var(--transition-fast);\n}\n\n.selection-checkbox {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--color-gray-300);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  background-color: var(--color-white);\n  flex-shrink: 0;\n}\n\n.selection-checkbox.checked {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.inner-check {\n  width: 10px;\n  height: 10px;\n  background-color: white;\n  border-radius: 2px;\n  animation: popIn var(--transition-fast);\n}\n\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes popIn {\n  from {\n    transform: scale(0);\n  }\n\n  to {\n    transform: scale(1);\n  }\n}\n\n.loading {\n  animation: pulse 1.5s infinite;\n}\n\n/* =============================================\n   RESPONSIVE - MOBILE\n   ============================================= */\n\n@media (max-width: 1024px) {\n\n  *,\n  *::before,\n  *::after {\n    transition: none !important;\n    animation-duration: 0s !important;\n  }\n\n  .app-container {\n    flex-direction: column;\n    overflow-x: hidden !important;\n    position: relative;\n    width: 100vw;\n  }\n\n  .sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    min-width: 100vw !important;\n    z-index: var(--z-modal);\n    background-color: var(--color-white);\n    display: none;\n    overflow-x: hidden !important;\n    transition: none !important;\n    transform: none !important;\n  }\n\n  .sidebar.open {\n    display: flex;\n  }\n\n  .chat-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100vw !important;\n    height: 100% !important;\n    overflow-x: hidden !important;\n    transition: none !important;\n    transform: none !important;\n  }\n\n  .message {\n    width: 100% !important;\n    display: flex !important;\n  }\n\n  .message.outgoing {\n    justify-content: flex-end !important;\n  }\n\n  .message.incoming {\n    justify-content: flex-start !important;\n  }\n\n  .message-container {\n    max-width: 85% !important;\n  }\n\n  .message-bubble {\n    width: fit-content !important;\n    max-width: 100% !important;\n  }\n\n  .chat-header {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background-color: var(--color-white);\n    padding: var(--space-2) var(--space-3);\n  }\n\n  /* Compacting header for mobile */\n  .chat-header-actions {\n    gap: var(--space-1) !important;\n  }\n\n  .chat-header-info {\n    gap: var(--space-2) !important;\n  }\n\n  /* Optimize AI Toggle on mobile */\n  .ai-toggle {\n    gap: 4px;\n    margin-right: 4px;\n  }\n\n  .ai-toggle-label {\n    font-size: 11px;\n    padding: 2px 4px;\n    background-color: var(--color-gray-100);\n    border-radius: 4px;\n  }\n\n  .ai-toggle-label svg {\n    width: 12px;\n    height: 12px;\n    margin-right: 2px !important;\n  }\n\n  /* Smaller toggle switch on mobile */\n  .toggle-switch {\n    width: 38px;\n    height: 22px;\n  }\n\n  .toggle-switch-handle {\n    width: 18px;\n    height: 18px;\n  }\n\n  .toggle-switch.active .toggle-switch-handle {\n    transform: translateX(16px);\n  }\n\n  /* Smaller header buttons on mobile */\n  .chat-header-actions .btn-icon {\n    padding: 6px;\n    width: 32px;\n    height: 32px;\n  }\n\n  .chat-input-container {\n    position: sticky;\n    bottom: 0;\n    z-index: 10;\n    background-color: var(--color-white);\n    padding: var(--space-2) var(--space-3);\n  }\n\n  .sidebar-header {\n    padding: var(--space-3);\n  }\n\n  .conversation-avatar {\n    width: 44px;\n    height: 44px;\n  }\n\n  /* Hide tag filter on very small screens */\n  @media (max-height: 600px) {\n    .sidebar-search+div {\n      max-height: 60px;\n      overflow: hidden;\n    }\n  }\n\n  /* Modal adjustments for mobile */\n  .modal {\n    width: 95%;\n    max-height: 90vh;\n    margin: var(--space-2);\n  }\n\n  /* Chat input mobile optimization */\n  .chat-input-container {\n    padding: var(--space-2) var(--space-3) !important;\n    padding-bottom: calc(var(--space-3) + env(safe-area-inset-bottom, 12px)) !important;\n    gap: var(--space-1) !important;\n  }\n\n  .chat-input-container .btn-icon {\n    padding: var(--space-1) !important;\n    width: 36px;\n    height: 36px;\n  }\n\n  .chat-input-container .btn-send {\n    width: 40px !important;\n    height: 40px !important;\n    padding: 0 !important;\n  }\n\n  .chat-input-container .message-input {\n    padding: var(--space-2) var(--space-3) !important;\n    min-width: 0;\n  }\n}\n\n/* Very small screens */\n@media (max-width: 375px) {\n  .sidebar-header {\n    padding: var(--space-2);\n  }\n\n  .conversation-item {\n    padding: var(--space-2) var(--space-3);\n  }\n\n  /* .status-indicator display:none removed */\n\n  /* Hide emoji button to save space on very small screens */\n  .chat-input-container>div:has(.btn-icon) {\n    display: none;\n  }\n\n  .chat-input-container .btn-icon:first-of-type {\n    display: flex;\n  }\n\n  .chat-input-container {\n    gap: 2px !important;\n  }\n\n  .chat-input-container .btn-icon {\n    width: 32px !important;\n    height: 32px !important;\n  }\n\n  .chat-input-container .btn-send {\n    width: 36px !important;\n    height: 36px !important;\n  }\n}\n\n/* =============================================\n   UTILITIES\n   ============================================= */\n\n.hidden {\n  display: none !important;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* =============================================\n   MOBILE SCROLL FIXES\n   ============================================= */\n\nhtml,\nbody {\n  overflow-x: hidden !important;\n  width: 100%;\n  max-width: 100vw;\n  position: fixed;\n  /* Previene rebote en iOS */\n  height: 100%;\n  overscroll-behavior-y: none;\n}\n\n.app-container {\n  height: 100%;\n  height: 100dvh;\n  width: 100%;\n  max-width: 100vw;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Permitir scroll solo donde es necesario */\n.sidebar,\n.chat-messages,\n.conversation-list,\n.modal-body {\n  overscroll-behavior: contain;\n}\n\n/* =============================================\n   UTILITIES & COMPONENTS ADDITIONS\n   ============================================= */\n\n/* Small icon button */\n.btn-icon-small {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: var(--radius-md);\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n  padding: 0;\n}\n\n.btn-icon-small:hover {\n  background-color: var(--color-gray-200);\n}\n\n/* Equivalent to tailwind hover:bg-gray-50 */\n.hover\\:bg-gray-50:hover {\n  background-color: var(--color-gray-50);\n}\n\n/* Highlight effect for quoted messages */\n.message-highlight {\n    animation: message-flash 2.5s ease-out;\n}\n\n@keyframes message-flash {\n    0% { background-color: rgba(18, 140, 126, 0.4); transform: scale(1.02); }\n    15% { background-color: rgba(18, 140, 126, 0.1); transform: scale(1); }\n    100% { background-color: transparent; }\n}\n\n/* =============================================\n   MESSAGE BUBBLE INTERACTIVE ELEMENTS\n   (global rules — avoid per-message style tags)\n   ============================================= */\n\n/* Show chevron menu button on bubble hover */\n.message-bubble:hover .menu-chevron {\n    opacity: 1 !important;\n}\n\n/* Always show chevron on touch devices */\n@media (hover: none) {\n    .menu-chevron {\n        opacity: 1 !important;\n        background: rgba(255,255,255,0.9) !important;\n    }\n}\n\n/* Show forward button on message hover */\n.message:hover .forward-btn {\n    opacity: 1 !important;\n    pointer-events: auto !important;\n}\n\n/* =============================================\n   TENANT SELECTOR RESPONSIVE LAYOUT\n   ============================================= */\n\n@media (max-width: 900px) {\n    .tenant-selector-page {\n        flex-direction: column !important;\n        width: 100% !important;\n        min-height: 100dvh !important;\n        height: auto !important;\n        overflow-x: hidden !important;\n        overflow-y: auto !important;\n    }\n\n    .tenant-selector-sidebar {\n        width: 100% !important;\n        min-width: 0 !important;\n        max-width: none !important;\n        flex: 0 0 auto !important;\n    }\n\n    .tenant-selector-nav {\n        flex: 0 0 auto !important;\n        padding: 16px 12px !important;\n    }\n\n    .tenant-selector-nav > button {\n        width: 100% !important;\n    }\n\n    .tenant-selector-main {\n        width: 100% !important;\n        height: auto !important;\n        min-height: 0 !important;\n        overflow: visible !important;\n        flex: 0 0 auto !important;\n    }\n\n    .tenant-selector-content {\n        max-width: none !important;\n        padding: 24px 16px 32px !important;\n    }\n\n    .tenant-selector-header {\n        align-items: flex-start !important;\n        flex-direction: column !important;\n        margin-bottom: 28px !important;\n    }\n\n    .tenant-selector-header h1 {\n        font-size: 22px !important;\n        line-height: 1.2 !important;\n    }\n\n    .tenant-selector-welcome {\n        margin-bottom: 24px !important;\n    }\n\n    .tenant-selector-welcome h2 {\n        font-size: 24px !important;\n        line-height: 1.2 !important;\n    }\n\n    .tenant-selector-welcome p {\n        font-size: 14px !important;\n    }\n\n    .tenant-selector-grid {\n        grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr)) !important;\n        gap: 16px !important;\n    }\n\n    .tenant-selector-card {\n        min-width: 0 !important;\n        padding: 20px !important;\n        border-radius: 18px !important;\n    }\n\n    .tenant-selector-new-card {\n        min-height: 190px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
